/** 상품 SNS/클립보드 공유 — 그누보드 쇼핑몰 공유하기에 대응 */
export async function shareMallProduct(payload: {
  title: string
  url: string
  text?: string
}): Promise<'shared' | 'copied' | 'failed'> {
  const url = payload.url
  const title = payload.title
  const text = payload.text || title

  try {
    if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
      await navigator.share({ title, text, url })
      return 'shared'
    }
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      return 'failed'
    }
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url)
      return 'copied'
    }
  } catch {
    /* fall through */
  }

  try {
    window.prompt('아래 주소를 복사해 주세요', url)
    return 'copied'
  } catch {
    return 'failed'
  }
}
